
import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';

import './globals-wave.css'
//import App from './test_chat';
import App from './chat-waveiate';


import reportWebVitals from './reportWebVitals';


const bottomPane = document.getElementById('bottom-panechild-doc');


if (bottomPane) {
  const root = ReactDOM.createRoot(bottomPane);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Element with id 'bottom-panechild-doc' not found");
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
